import {AccountingMatrixDatagridGrid} from '../../components/AccountingMatrixDatagridGrid';
import {getAccountingMatrixDatagridM13VatConfig} from './getAccountingMatrixDatagridM13VatConfig';

export function AccountingMatrixDatagridM13Vat() {
  return <AccountingMatrixDatagridGrid config={getAccountingMatrixDatagridM13VatConfig()} />;
}
